import * as tslib_1 from "tslib";
import { OnInit, Injector, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SecondPageEditBase } from '../../lib-shared/classes/base/second-page-edit-base';
import { User } from '../../lib-shared/models/user';
import { ActiveCommentTypeEnum } from '../../lib-shared/types/activeCommentType.enum';
import { WmTaskCommentLikesService } from '../../work/services/WmTaskCommentLikes.service';
var CommentGComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CommentGComponent, _super);
    function CommentGComponent(_injector, _WmTaskCommentLikesService) {
        var _this = _super.call(this, null, _injector) || this;
        _this._injector = _injector;
        _this._WmTaskCommentLikesService = _WmTaskCommentLikesService;
        _this.deleteComment = new EventEmitter();
        _this.updateComment = new EventEmitter();
        _this.addComment = new EventEmitter();
        _this.setActiveComment = new EventEmitter();
        _this.emitData = new EventEmitter();
        _this.activeCommentType = ActiveCommentTypeEnum;
        _this.replyId = null;
        _this.canEdit = false;
        _this.canDelete = false;
        _this.isReplyingComment = false;
        _this.isEditingComment = false;
        return _this;
    }
    CommentGComponent.prototype.ngOnInit = function () {
        this.replyId = this.parentId ? this.parentId : this.comment.id;
        this.canEdit = this.currentUser.userId == this.comment.userCreated.userId;
        this.canDelete = this.currentUser.userId == this.comment.userCreated.userId;
        this.updateActiveState();
    };
    CommentGComponent.prototype.ngOnChanges = function (changes) {
        if (changes['activeComment']) {
            this.updateActiveState();
        }
    };
    CommentGComponent.prototype.updateActiveState = function () {
        if (!this.activeComment) {
            this.isReplyingComment = false;
            this.isEditingComment = false;
        }
        else {
            this.isReplyingComment = this.activeComment.id === this.comment.id && this.activeComment.type === 'replying';
            this.isEditingComment = this.activeComment.id === this.comment.id && this.activeComment.type === 'editing';
        }
    };
    CommentGComponent.prototype.likeComments = function (idTaskComment, idTask) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._WmTaskCommentLikesService.Like(idTaskComment, idTask)
                            .then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var indexUser;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                if (response.status) {
                                    this.comment.userLiked = !response.data.isDeleted;
                                    if (!response.data.isDeleted) {
                                        this.comment.countLike++;
                                        this.comment.likeUser.push({
                                            userId: this.currentUser.userId,
                                            name: this.currentUser.userName
                                        });
                                    }
                                    else {
                                        this.comment.countLike--;
                                        indexUser = this.comment.likeUser.findIndex(function (x) { return x.userId == _this.currentUser.userId; });
                                        this.comment.likeUser.splice(indexUser, 1);
                                    }
                                }
                                return [2 /*return*/];
                            });
                        }); }, function () {
                            _this._notifierService.showHttpUnknowError();
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CommentGComponent;
}(SecondPageEditBase));
export { CommentGComponent };
